import { atomFamily } from 'recoil';
import {
  GridColumnVisibilityModel,
  GridSortModel,
} from '@spotgamma/x-data-grid-premium';
import {
  Filter,
  FilterConfig,
  OptionsFeedColumnKey,
  OptionsFeedColumnSizes,
} from 'types/tape';
import { TapeFilterTab } from 'config/tape';
import {
  DEFAULT_TAPE_COL_VISIBILITY,
  DEFAULT_TNS_FIELDS,
  DEFAULT_TAPE_COL_SIZES,
  DEFAULT_TAPE_CONTRACTS_COL_VISIBILITY,
  CONTRACT_DATA_COLUMN_KEYS,
  DEFAULT_TAPE_CONTRACT_COL_SIZES,
} from 'config/tape';

// Per-Canvas-instance tape state using atomFamily keyed by component ID.
// No recoilPersist — persistence is via Canvas DB.

export const canvasTapeNewFiltersFamily = atomFamily<Filter[], number>({
  key: 'canvas-tape-newFilters',
  default: [],
});

export const canvasTapeActiveCustomFilterFamily = atomFamily<
  FilterConfig | undefined,
  number
>({
  key: 'canvas-tape-activeCustomFilter',
  default: undefined,
});

export const canvasTapeSavedFiltersFamily = atomFamily<FilterConfig[], number>({
  key: 'canvas-tape-savedFilters',
  default: [],
});

export const canvasTapeFlowLiveFamily = atomFamily<boolean, number>({
  key: 'canvas-tape-flowLive',
  default: true,
});

export const canvasTapeColumnVisibilityFamily = atomFamily<
  GridColumnVisibilityModel,
  number
>({
  key: 'canvas-tape-colVisibility',
  default: DEFAULT_TAPE_COL_VISIBILITY,
});

export const canvasTapeColumnSortModelFamily = atomFamily<
  GridSortModel,
  number
>({
  key: 'canvas-tape-colSortModel',
  default: [{ field: OptionsFeedColumnKey.Time, sort: 'desc' as const }],
});

export const canvasTapeColumnOrderFamily = atomFamily<
  OptionsFeedColumnKey[],
  number
>({
  key: 'canvas-tape-colOrder',
  default: DEFAULT_TNS_FIELDS,
});

export const canvasTapeColumnSizesFamily = atomFamily<
  OptionsFeedColumnSizes,
  number
>({
  key: 'canvas-tape-colSizes',
  default: DEFAULT_TAPE_COL_SIZES,
});

export const canvasTapeFilterActiveTabFamily = atomFamily<
  TapeFilterTab,
  number
>({
  key: 'canvas-tape-filterActiveTab',
  default: TapeFilterTab.NewFilter,
});

export const canvasTapeFilterPanelOpenFamily = atomFamily<boolean, number>({
  key: 'canvas-tape-filterPanelOpen',
  default: false,
});

export const canvasTapeActiveWatchlistIdsFamily = atomFamily<number[], number>({
  key: 'canvas-tape-activeWatchlistIds',
  default: [],
});

// Contract data atoms (needed for Tape props even if not rendered in Canvas)
export const canvasTapeContractsVisibilityFamily = atomFamily<
  GridColumnVisibilityModel,
  number
>({
  key: 'canvas-tape-contractsVisibility',
  default: DEFAULT_TAPE_CONTRACTS_COL_VISIBILITY,
});

export const canvasTapeContractsSortModelFamily = atomFamily<
  GridSortModel,
  number
>({
  key: 'canvas-tape-contractsSortModel',
  default: [],
});

export const canvasTapeContractsColumnOrderFamily = atomFamily<
  OptionsFeedColumnKey[],
  number
>({
  key: 'canvas-tape-contractsColOrder',
  default: CONTRACT_DATA_COLUMN_KEYS,
});

export const canvasTapeContractsColumnSizesFamily = atomFamily<
  OptionsFeedColumnSizes,
  number
>({
  key: 'canvas-tape-contractsColSizes',
  default: DEFAULT_TAPE_CONTRACT_COL_SIZES,
});
